import React, {FC, RefObject} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Dropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownHeader} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownHeader';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ApplicationsPanelId} from '../../../../../store/panels/panelStateBase';
import {NonNativeSidePanelFrame} from '../../../../../store/stateless/sidePanelFrameSelectors';
import {PopupApplicationContainer} from '../../../../applications/popup/popupApplicationContainer';

/*
 * Constants.
 */

const panelWidth = 300; // px.
const panelHeight = 430; // px.

/*
 * Props.
 */

interface ApplicationComposerEntryPointPanelProps {
  panelId: ApplicationsPanelId;
  anchor: RefObject<HTMLDivElement>;
  frame: NonNativeSidePanelFrame;
  onRequestClose: Handler;
}

/*
 * Style.
 */

const StyledHeaderTitleDiv = styled.div`
  line-height: 39px;
  text-align: center;
  font-weight: ${fontWeights.medium};
`;

/*
 * Component.
 */

export const ApplicationComposerEntryPointPanel: FC<ApplicationComposerEntryPointPanelProps> = (props) => {
  const {panelId, anchor, frame, onRequestClose} = props;
  return (
    <Dropdown anchor={anchor} width={panelWidth} height={panelHeight} onRequestClose={onRequestClose}>
      <DropdownHeader>
        <StyledHeaderTitleDiv>{frame.name}</StyledHeaderTitleDiv>
      </DropdownHeader>
      <PopupApplicationContainer panelId={panelId} frame={frame} onRequestClose={onRequestClose} />
    </Dropdown>
  );
};
